import { render, staticRenderFns } from "./CargoQuoteRefPremium.vue?vue&type=template&id=25b36770&"
import script from "./CargoQuoteRefPremium.vue?vue&type=script&lang=js&"
export * from "./CargoQuoteRefPremium.vue?vue&type=script&lang=js&"
import style0 from "./CargoQuoteRefPremium.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoQuoteRefPremium.vue"
export default component.exports